import GroupOptionsViewMode from "components/admin/GroupOptionsViewMode";
import UserAccessControlViewMode from "components/admin/UserAccessControlViewMode";
import GroupForm from "components/form/GroupForm";
import SiteForm from "components/form/SiteForm";
import PageLoader from "components/general/PageLoader";
import Seo from "components/general/Seo";
import { Tab, TabContainer } from "components/general/Tabs";
import TitledContainer from "components/general/TitledContainer";
import { Box, Button, Text, VStack } from "components/ui";
import { H3, H4 } from "components/ui/Typography";
import { useLocalSearchParams } from "expo-router";
import { Group, ListTree, PenLine } from "lucide-react-native";
import React from "react";
import { Pressable } from "react-native";
import { useGetGroupByIdQuery } from "store/abcoApi";

// TODO implement all permissions
// {
// 	header: "General",
// },
// "Manage Sites",
// "Manage approved stocklists",
// "Create site catelouges",
// "Manage budgets",
// "View reports",
// "View invoices",
// "Allowed to order",
// "View Prices",
// "View Equipment",
// "View site budget",
// {
// 	header: "Stocklist /catalogue",
// },
// "View non stocklist item",
// "Purchase non stocklist item",
// "Purchase non catalogued item",
// {
// 	header: "Approval Required",
// },
// "All Orders",
// "Non stocklist items",
// "Non catalogued items",
// "Orders over site budget",
// "Orders over group budget",
// "Orders over xxx budget",

export default function Page() {
	const { id } = useLocalSearchParams<{ id: string }>();

	const [editMode, setEditMode] = React.useState(false);
	const [userAccessEditMode, setUserAccessEditMode] = React.useState(false);
	const [groupOptionsEditMode, setGroupOptionsEditMode] = React.useState(false);
	const [showSave, setShowSave] = React.useState(false);
	const {
		data: group,
		isLoading,
		isFetching,
		isError,
	} = useGetGroupByIdQuery({
		id: Number(id),
	});

	if (isLoading || group == null) {
		return <PageLoader />;
	}
	return (
		<Box>
			<Seo title={"Group - " + group.name + " | Abconet"} description={""} />
			<Box flexDirection="row" alignItems="center" flexWrap="wrap" gap={8}>
				<Box flex={1}>
					<Pressable>
						<H3 numberOfLines={2}>{group.name}</H3>
					</Pressable>
				</Box>
				{group.parent == null && (
					<Button gap={8}>
						<ListTree color="#000000" />
						<Text>Master group</Text>
					</Button>
				)}
			</Box>
			<Box py={16}>
				<TabContainer showSave={false}>
					<Tab title="View" id="view">
						<VStack gap={24}>
							<TitledContainer
								zIndex={9}
								customTitle={() => {
									return (
										<Box flexDirection="row" alignItems="center">
											<VStack gap={12}>
												<Text fontSize={20} fontWeight={"bold"}>
													User access and control
												</Text>
												{userAccessEditMode && <Text fontSize={14}>Control what users have access to</Text>}
											</VStack>

											<Button
												onPress={() => {
													const newUserAccessEditMode = !userAccessEditMode;
													setUserAccessEditMode(newUserAccessEditMode);
													setShowSave(groupOptionsEditMode || newUserAccessEditMode);
												}}
												ml="auto"
												gap={8}
											>
												<PenLine color={"#000000"} />
												<Text>Edit</Text>
											</Button>
										</Box>
									);
								}}
							>
								<Box padding={24}>
									<UserAccessControlViewMode id={id} group={group} isEditMode={userAccessEditMode} />
								</Box>
							</TitledContainer>
							<TitledContainer
								customTitle={() => {
									return (
										<Box flexDirection="row" alignItems="center">
											<Text fontSize={20} fontWeight={"bold"}>
												Group options
											</Text>
											<Button
												onPress={() => {
													const newGroupOptionsEditMode = !groupOptionsEditMode;
													setGroupOptionsEditMode(newGroupOptionsEditMode);
													setShowSave(newGroupOptionsEditMode || userAccessEditMode);
												}}
												ml="auto"
												gap={8}
											>
												<PenLine color={"#000000"} />
												<Text>Edit</Text>
											</Button>
										</Box>
									);
								}}
							>
								<Box padding={24}>
									<GroupOptionsViewMode isEditMode={groupOptionsEditMode} group={group} />
								</Box>
							</TitledContainer>
						</VStack>
					</Tab>
					{group.site == null && (
						<Tab title="Add site" id="add-site">
							<TitledContainer
								customTitle={() => {
									return (
										<Box flexDirection="row" alignItems="center">
											<Text fontSize={20} fontWeight={"bold"}>
												Add site
											</Text>
										</Box>
									);
								}}
							>
								<Box padding={24}>
									<SiteForm site={null} parentId={group.id ?? 0} />
								</Box>
							</TitledContainer>
						</Tab>
					)}
					{group.site == null && (
						<Tab title="Add group" id="add-group">
							<TitledContainer
								customTitle={() => {
									return (
										<Box flexDirection="row" alignItems="center">
											<Text fontSize={20} fontWeight={"bold"}>
												Add Group
											</Text>
										</Box>
									);
								}}
							>
								<Box padding={24}>
									<GroupForm parentId={group.id ?? 0} />
									{/* <SiteForm site={null} parentId={group.id} /> */}
								</Box>
							</TitledContainer>
						</Tab>
					)}
					{group.site !== null && (
						<Tab title="Edit Site" id="edit-site">
							<TitledContainer
								customTitle={() => (
									<Text fontSize={20} fontWeight={"bold"}>
										Edit Site
									</Text>
								)}
							>
								<Box padding={24}>
									<SiteForm site={group.site ?? null} parentId={group.id ?? 0} />
								</Box>
							</TitledContainer>
						</Tab>
					)}
				</TabContainer>
			</Box>
		</Box>
	);
}
